import axios from "axios";
import store from "../store/index";
import useDisableElement from "@/composables/disableElements";
import router from "@/router/index";
import { createFetch } from "@vueuse/core";

import { msalInstance } from "../authConfig";

const baseUrl = process.env.VUE_APP_ENDPOINT_FUNCTIONS;
const baseUrlV2 = process.env.VUE_APP_ENDPOINT_FUNCTIONS_V2;
const baseUrlInfoQr = process.env.VUE_APP_ENDPOINT_QR;
const baseUrlPayments = process.env.VUE_APP_ENDPOINT_PAYMENTS;
const baseUrlAzureMaps = process.env.VUE_APP_AZURE_MAPS_API;
const baseUrlSportpay = process.env.VUE_APP_ENDPOINT_SPORTPAY;

let dbManagControlloTokenFCH = axios.create({
  baseURL: baseUrl,
});

let dbManag = axios.create({
  baseURL: baseUrl,
});
dbManag.interceptors.request.use((config) => {
  store.state.NumberPendingRequests.numberOfAjaxCAllPending++;
  // numberOfAjaxCAllPending++;
  let token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "bearer " + token;
  config.headers["X-Referer"] = window.location.href;
  return config;
});
dbManag.interceptors.response.use(
  async function (response) {
    store.state.NumberPendingRequests.numberOfAjaxCAllPending--;
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const actualRoute = router.currentRoute.value.name;
    // se la risposta contiene campi locked o read only
    if (response.data.campi_Locked || response.data.read_only) {
      // if (!response.data.read_only) { // test readonly
      // salva un oggetto contenente il route attuale, i campi locked e read only
      const campiLockedPageobj = {
        route: actualRoute,
        campi_Locked: response.data.campi_Locked,
        read_only: response.data.read_only,
      };
      store.state.CampiLocked.arrayCampiLocked.push(campiLockedPageobj);
      // chiama la funzione per bloccare i campi locked o attivare readonly se presente
      document.addEventListener(
        "DOMContentLoaded",
        useDisableElement(actualRoute, "dbManag")
      );
      if (response.config.url.includes("/anagrafiche/persone/view")) {
        const anagraficaCampiLockedSet =
          store.state.CampiLocked.arrayCampiLocked.some((element) =>
            element.route.includes("/anagrafica-persona")
          );
        if (!anagraficaCampiLockedSet) {
          const objAnagrafica = {
            route: "anagrafica-persona",
            campi_Locked: response.data.campi_Locked,
            read_only: response.data.read_only,
          };
          store.state.CampiLocked.arrayCampiLocked.push(objAnagrafica);
        }
      }
    }
    // let error = new Error("ERRORE PROVA STATUS 525");
    // error.response.data.statusCode = 525;
    // throw error;
    if (response.data.statusCode == 525) {
      router.push("/manutenzione");
    }
    if (response.data.message == "Utente non autorizzato") {
      const idTokenHint = localStorage.getItem("tokenAdb2c");

      localStorage.clear();
      await msalInstance.logoutRedirect({
        idTokenHint: idTokenHint,
      });
    }
    // useDisableElement(actualRoute);
    return response;
  },
  function (error) {
    store.state.NumberPendingRequests.numberOfAjaxCAllPending--;
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response.data.statusCode == 525) {
      router.push("/manutenzione");
    }
    return Promise.reject(error);
  }
);

let downloadFile = axios.create({
  baseURL: baseUrl,
  responseType: "blob",
  /* other custom settings */
});
downloadFile.interceptors.request.use((config) => {
  let token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "bearer " + token;
  config.headers["Content-Disposition"] = "attachment";
  config.headers["Content-Type"] = "application/octet-stream; charset=utf-8";
  config.headers["X-Referer"] = window.location.href;
  return config;
});

let downloadFileV2 = axios.create({
  baseURL: baseUrlV2,
  responseType: "blob",
  /* other custom settings */
});
downloadFileV2.interceptors.request.use((config) => {
  let token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "bearer " + token;
  config.headers["Content-Disposition"] = "attachment";
  config.headers["Content-Type"] = "application/octet-stream; charset=utf-8";
  config.headers["X-Referer"] = window.location.href;
  return config;
});

let sendFile = axios.create({
  baseURL: `${baseUrl}`,
  // data: bodyFormData,
  headers: { "Content-Type": "multipart/form-data" },

  /* other custom settings */
});
sendFile.interceptors.request.use((config) => {
  let token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "bearer " + token;
  config.headers["X-Referer"] = window.location.href;
  return config;
});

let sendFileV2 = axios.create({
  baseURL: `${baseUrlV2}`,
  // data: bodyFormData,
  headers: { "Content-Type": "multipart/form-data" },

  /* other custom settings */
});
sendFileV2.interceptors.request.use((config) => {
  let token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "bearer " + token;
  config.headers["X-Referer"] = window.location.href;
  return config;
});

let baseApi = axios.create({
  baseURL: `${baseUrl}/sistema`,
});
baseApi.interceptors.request.use((config) => {
  let token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "bearer " + token;
  config.headers["X-Referer"] = window.location.href;
  return config;
});
baseApi.interceptors.response.use(function (response) {
  if (response.data.menu) {
    response.data.menu[0].comandi_enabled.forEach((element) => {
      store.state.CampiLocked.campiEnabled.push(element);
    });
    store.state.Menu.pagineAutorizzate = response.data.menu[0].pages;
  }
  return response;
});

let baseApiQrCode = axios.create({
  baseURL: baseUrlInfoQr,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("tokenAdb2c"),
    "X-Referer": window.location.href,
    Referer: window.location.href,
  },
});

let dbManagV2 = axios.create({
  baseURL: baseUrlV2,
});
dbManagV2.interceptors.request.use((config) => {
  store.state.NumberPendingRequests.numberOfAjaxCAllPendingV2++;
  // numberOfAjaxCAllPendingV2++;
  let token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "bearer " + token;
  config.headers["X-Referer"] = window.location.href;
  return config;
});
dbManagV2.interceptors.response.use(
  function (response) {
    store.state.NumberPendingRequests.numberOfAjaxCAllPendingV2--;
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const actualRoute = router.currentRoute.value.name;
    // se la risposta contiene campi locked o read only
    if (response.data.campi_Locked || response.data.read_only) {
      // if (!response.data.read_only) { // test readonly
      // salva un oggetto contenente il route attuale, i campi locked e read only
      const campiLockedPageobj = {
        route: actualRoute,
        campi_Locked: response.data.campi_Locked,
        read_only: response.data.read_only,
      };
      store.state.CampiLocked.arrayCampiLocked.push(campiLockedPageobj);
      // chiama la funzione per bloccare i campi locked o attivare readonly se presente
      document.addEventListener(
        "DOMContentLoaded",
        useDisableElement(actualRoute, "dbManagV2")
      );
      if (response.config.url.includes("/anagrafiche/persone/view")) {
        const anagraficaCampiLockedSet =
          store.state.CampiLocked.arrayCampiLocked.some((element) =>
            element.route.includes("/anagrafica-persona")
          );
        if (!anagraficaCampiLockedSet) {
          const objAnagrafica = {
            route: "anagrafica-persona",
            campi_Locked: response.data.campi_Locked,
            read_only: response.data.read_only,
          };
          store.state.CampiLocked.arrayCampiLocked.push(objAnagrafica);
        }
      }
    }
    // let error = new Error("ERRORE PROVA STATUS 525");
    // error.response.data.statusCode = 525;
    // throw error;
    if (response.data.statusCode == 525) {
      router.push("/manutenzione");
    }
    // useDisableElement(actualRoute);
    return response;
  },
  function (error) {
    store.state.NumberPendingRequests.numberOfAjaxCAllPendingV2--;
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response.data.statusCode == 525) {
      router.push("/manutenzione");
    }
    return Promise.reject(error);
  }
);
export const useFetchJSON = createFetch({
  baseUrl: baseUrl,
  combination: "overwrite",
  options: {
    immediate: false,
    // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
    async beforeFetch({ options }) {
      options.headers = {
        ...options.headers,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("tokenAdb2c")}`,
        "X-Referer": window.location.href,
      };

      return { options };
    },
  },
});

export const useFetchPayments = createFetch({
  baseUrl: baseUrlPayments,

  options: {
    immediate: false,
    // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
    async beforeFetch({ options }) {
      options.headers = {
        ...options.headers,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("tokenAdb2c")}`,
        "X-Referer": window.location.href,
      };

      return { options };
    },
  },
  fetchOptions: {
    mode: "cors",
    method: "post",
  },
});

export const useFetchFile = createFetch({
  baseUrl: baseUrl,
  combination: "overwrite",
  options: {
    // beforeFetch in pre-configured instance will only run when the newly spawned instance do not pass beforeFetch
    async beforeFetch({ options }) {
      options.headers = {
        ...options.headers,
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("tokenAdb2c")}`,
        "X-Referer": window.location.href,
      };

      return { options };
    },
  },
});

let dbManagAzureMaps = axios.create({
  baseURL: baseUrlAzureMaps,
});

let sportpay = axios.create({
  baseURL: baseUrlSportpay,
});
sportpay.interceptors.request.use((config) => {
  const token = localStorage.getItem("tokenAdb2c");
  config.headers["Authorization"] = "bearer " + token;
  config.headers["X-Referer"] = window.location.href;
  return config;
});

const services = {
  useFetchJSON,
  dbManagAzureMaps,
  dbManag,
  dbManagV2,
  baseApi,
  downloadFile,
  downloadFileV2,
  baseUrl,
  baseUrlV2,
  sendFile,
  sendFileV2,
  baseApiQrCode,
  dbManagControlloTokenFCH,
  sportpay,
};

export default services;
